.anchor {
  display: inline-flex;
  max-width: 100%;
}

.tooltip {
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--z-tooltip);
  max-width: min(20rem, calc(100vw - 16px));
  padding: var(--space-1-5) var(--space-2-5);
  border-radius: var(--radius-sm);
  background-color: var(--color-tooltip-bg);
  color: var(--color-tooltip-fg);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-snug);
  box-shadow: var(--shadow-md);
  pointer-events: auto;
  overflow-wrap: break-word;
  animation: fade-in var(--duration-fast) var(--ease-out);
}

.tooltip[hidden] {
  display: none;
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(2px);
  }
}

@media (forced-colors: active) {
  .tooltip {
    border: 1px solid CanvasText;
  }
}
